import React from "react";

export const GridReactContext = React.createContext({
    refreshKey: 0,
    filterDisabled: {},
    filterModel: {}, //only used for communication between components
    sortModel: {}, //only used for communication between components
    selectionModel: [], // Array of selected row IDs
    selectedRows: [], // Array of full selected row objects (with all data)
    paginationModel: {},
    triggerTableRefresh: () => {
    },
    modifyFilterDisabled: () => {
    },
    updateFilterModel: () => {
    },
    getFilterModel: () => {
    },
    setSelectionModelToContext: () => {},
    updateSelectedRows: () => {},
});


export const GridReactContextProvider = ({children}) => {
    const [refreshKey, setRefreshKey] = React.useState(0)
    const [filterModel, setFilterModel] = React.useState({})
    const [sortModel, setSortModel] = React.useState({})
    const [selectionModel, setSelectionModel] = React.useState([])
    const [selectedRows, setSelectedRows] = React.useState([])
    const [paginationModel, setPaginationModel] = React.useState({})



    const triggerTableRefresh = () => {
        setRefreshKey(prevKey => prevKey + 1)
    }
    const updateFilterModel = (filterModel) => {
        setFilterModel(filterModel)
    }
    const getFilterModel = ({companies}) => {
        return filterModel
    }
    const updateSortModel = (sortModel) => {
        setSortModel(sortModel)
    }
    const updateSelectionModel = (selectionModel) => {
        setSelectionModel(selectionModel)
    }
    const updateSelectedRows = (selectedRows) => {
        setSelectedRows(selectedRows)
    }
    const updatePaginationModel = (paginationModel) => {
        setPaginationModel(paginationModel)
    }
    const setSelectionModelToContext = (selectionModel) => {
        setSelectionModel(selectionModel)
    }

    return <GridReactContext.Provider value={{
        refreshKey,
        setSelectionModelToContext,
        triggerTableRefresh,
        filterModel,
        updateFilterModel,
        sortModel,
        updateSortModel,
        paginationModel,
        updatePaginationModel,
        selectionModel,
        updateSelectionModel,
        selectedRows,
        updateSelectedRows,
    }}>
        {children}
    </GridReactContext.Provider>
}
